import { TEXT_ALERT } from '../../constants/constantValues';

/**
 *
 * @param {*} product
 */
export function monthsProduct(product) {
    var minMonth = 3;
    var maxMonth = 36;
    var months = [];

    if (product === 2) {
        maxMonth = 48;
    }

    if (product === 40) {
        maxMonth = 60;
    }

    if (product === 17 || product === 47) {
        maxMonth = 72;
    }

    //se modifica plazo por solicitud de mauricio garcias , ajustes fondos de garantias
    if (product === 18) {
        minMonth = 1;
        maxMonth = 60;
    }

    for (let index = minMonth; index <= maxMonth; index++) {
        months.push({
            label: index === 1 ? `${index} Mes` : `${index} Meses`,
            value: index,
        });
    }
    return months;
}

/**
 *
 * @param {*} type
 * @param {*} message
 */
export function validationDefault(type, column) {
    var obj = {};
    type.map((item) => {
        return (obj[item] = {
            value: true,
            message: typeValidation(item, column),
        });
    });
    return obj;
}

function typeValidation(type, column) {
    switch (type) {
        case 'required':
            return `El campo ${column} es requerido`;
        default:
            return;
    }
}

export function validationDefaultNew(data, column) {
    var obj = {};
    data.map((item) => {
        return (obj[item.type] = {
            value: item.value,
            message: typeValidationNew(item, column),
        });
    });
    return obj;
}

function typeValidationNew(item, column) {
    switch (item.type) {
        case 'required':
            return `El campo ${column} es requerido`;
        case 'maxLength':
            return `El campo ${column} debe ser máximo a ${item.value} caracteres`;
        case 'minLength':
            return `El campo ${column} debe ser mínimo a ${item.value} caracteres`;
        case 'min':
            return `El campo ${column} debe ser mínimo ${item.value}`;
        case 'max':
            return `El campo ${column} debe ser máximo ${item.value}`;
        case 'pattern':
            return item.mesagge
                ? item.mesagge
                : `El campo ${column} debe ser un correo electrónico válido`;
        case 'maxValueString':
            return `El campo ${column} debe ser máximo ${item.value}`;
        case 'minValueCelphone':
            return `El campo ${column} debe ser igual a ${item.value} caracteres`;
        default:
            return;
    }
}

export function defaultYearReport() {
    let date = new Date();
    let year = date.getFullYear();
    return { value: year, label: year };
}

export function defaultMonthReport() {
    let date = new Date();
    let month = date.getMonth();
    let monthText = '';

    if (month === 0) monthText = 'ENERO';
    if (month === 1) monthText = 'FEBRERO';
    if (month === 2) monthText = 'MARZO';
    if (month === 3) monthText = 'ABRIL';
    if (month === 4) monthText = 'MAYO';
    if (month === 5) monthText = 'JUNIO';
    if (month === 6) monthText = 'JULIO';
    if (month === 7) monthText = 'AGOSTO';
    if (month === 8) monthText = 'SEPTIEMBRE';
    if (month === 9) monthText = 'OCTUBRE';
    if (month === 10) monthText = 'NOVIEMBRE';
    if (month === 11) monthText = 'DICIEMBRE';

    return { value: month + 1, label: monthText };
}

export function defaultDate() {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

export function plazoCargaSegura() {
    const dateHoy = new Date();
    let yearActual = dateHoy.getFullYear();
    let fechaSura = new Date(`${yearActual}/04/25`);
    let fechaActual = new Date(defaultDate());
    if (fechaSura < fechaActual)
        fechaSura = fechaSura.setFullYear(fechaSura.getFullYear() + 1);

    let resta = fechaSura - fechaActual;
    let diffDays = Math.floor(resta / (1000 * 60 * 60 * 24));
    let plazoCalculado = Math.round(diffDays / 30);

    return {
        value: plazoCalculado ? plazoCalculado : 3,
        label: `${plazoCalculado ? plazoCalculado : 3}  meses`,
    };
}
export function maxModeloVehiculo() {
    const dateHoy = new Date();
    let MaxYearModel = dateHoy.getFullYear() + 1;
    return MaxYearModel;
}

export function getErrorMessage(error, text) {
    let msgError =
        error?.response?.data?.detail ||
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        text ||
        TEXT_ALERT.ERROR_TEXT;
    return msgError;
}
